import React from 'react';
import cartApi from '../../store/cartApi.js'
import { storePubSub } from '../../store/applications/consts.js';
import { utils, TranslationUtil } from '../../utils';

class FullscreenCartButton extends React.Component {
  constructor(props) {
    super(props);

    this.addToCart = this.addToCart.bind(this);
    this.state = {
      buttonClassNames: 'add-to-cart-button'
    }
  }

  addToCart() {
    if (this.props.isSettings) {
      return;
    }

    if (this.props.onAddToCartRequest) {
      this.props.onAddToCartRequest()
    }
  }

  render() {
    const cartItems = this.props.cartItems || [];
    const buttonClassNames = cartItems.length ? 'add-to-cart-button checkout-link-appears' : 'add-to-cart-button';

    let buttonDefaultText = TranslationUtil ? TranslationUtil.getByKey('Gallery_ArtStore_UOU_Add_To_Cart_Button') : ''
    let buttonText = this.props.styleParams.addToCartButtonText || buttonDefaultText

    return (
      <button
        className={buttonClassNames}
        tabIndex={utils.getTabIndex('fullscreenCartButton')}
        aria-label={buttonText}
        onClick={this.addToCart}
      >
        <div>
          {buttonText}
        </div>
        <div className='overlay' />
      </button>
    )
  }
}

export default FullscreenCartButton;



// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenCartButton.js